import { MathX } from "../math/MathX";

export class YBColorSpace
{
  static hueToYB( hue:number )
  {
    return MathX.repeatPolar( hue - 240, 180 );    
  }

  static ybToHue( yb:number ) 
  {
    return MathX.repeat( yb + 240, 360 );
  }

  static changeHue( hue:number, change:number )
  {
    let yb = YBColorSpace.hueToYB( hue );
    
    let absYB = Math.abs( yb );

    absYB = MathX.clamp( absYB + change, 0, 180 );

    let realYB = yb < 0 ? -absYB : absYB;

    return this.ybToHue( realYB );
  }


}
